//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'

import { OpConsumer, OpDataTypeInGroup } from '../../../models/core'

import { LoggerService } from '../../common/common.module'
import { LocalDictionaryFactory } from './../../api/api.module'
import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { CreateEditSection } from './../../common/common.create-edit'

import { CommonHelper, ConvertHelper, EventsNames, LocalizationHelper, ToastHelper } from '../../../helpers'
import { PopupType } from '../../../helpers/popup-manager'
import { ConsumerHelper } from '../consumers.helper'
import { LogHelper } from '../../../helpers'
import { DataTypeGroupService } from '../../../services/data-type'
import { UserSessionService } from '../../../services/user-session'

interface ConsumerCreateEditScope extends CreateEditScope {

}

export class ConsumerCreateEditController extends CreateEditController {

    // #region Members

    private referenceValue: OpConsumer

    private consumerSection: CreateEditSection
    private actorSection: CreateEditSection

    // #endregion


    // #region Ctor

    constructor(
        private $scope: ConsumerCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        private userSessionService: UserSessionService,
        private dataTypeGroupService: DataTypeGroupService,
        private localDictionary: LocalDictionaryFactory,

        private referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

    private onInit(args: any[]): void {

        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            $.when(
                this.getActorSections(),
                this.getConsumerSections()
            )
                .then((actorSection: CreateEditSection, consumerSection: CreateEditSection) => {
                    this.actorSection = actorSection
                    this.consumerSection = consumerSection

                    createEditInitParams.sections = [this.consumerSection, this.actorSection]

                    this.referenceValue = createEditInitParams ? <OpConsumer>createEditInitParams.referenceObject : null

                    if (this.referenceValue != null) {
                        this.referenceValue = ConsumerHelper.getFakeObjectWithFullDataList(this.referenceValue)
                        createEditInitParams.referenceObject = this.referenceValue
                    }

                    this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

                    if (this.referenceValue && this.referenceValue.idObject > 0) {
                        this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
                        this.$scope.popupType = PopupType.CREATE_EDIT_POPUP
                    } else {
                        this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
                        this.$scope.popupType = PopupType.CREATE_EDIT_POPUP
                    }

                    this.$timeout(() => {
                        this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
                    })
                })
                .fail((error) => {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                    ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                    LogHelper.log(ConsumerHelper.LOG_PREFIX, `Unable to get sections. Error: ${errorMsg}.`)

                })
        }
    }

    private onInitBulk(args: any[]): void {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            this.$scope.gridData = args[0]

            if (args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()

        const consumerObject: OpConsumer = ConsumerHelper.createConsumerObject(objectToSave, this.consumerSection.dataTypesToEdit, this.actorSection.dataTypesToEdit)

        ConsumerHelper
            .saveConsumer(this.userSessionService.getDataProvider(), consumerObject, this.moduleName)
            .then((savedObject: OpConsumer) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()

        const consumerObject: OpConsumer = ConsumerHelper.createConsumerObject(objectToSave, this.consumerSection.dataTypesToEdit, this.actorSection.dataTypesToEdit)

        ConsumerHelper
            .saveConsumer(this.userSessionService.getDataProvider(), consumerObject, this.moduleName, true)
            .then((savedObject: OpConsumer) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onSubmit: null,
            onClose: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.consumerSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave)
        }
    }

    private getActorSections(): JQueryPromise<CreateEditSection> {
        return $.when(
            this.dataTypeGroupService.getDataTypeInGroupByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT,
                Enums.SimaxModuleName.Actor
            ),
            this.dataTypeGroupService.getDataTypeInGroupByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED,
                Enums.SimaxModuleName.Actor
            ))
            .then((paramsToEdit: OpDataTypeInGroup[], requiredParams: OpDataTypeInGroup[]) => {
                return {
                    name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Actor),
                    type: 'form',
                    dataTypesToEdit: paramsToEdit,
                    dataTypesRequired: requiredParams
                }
            })

    }

    private getConsumerSections(): JQueryPromise<CreateEditSection> {
        return this.dataTypeGroupService.getDataTypeInGroupByCategory(
            Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT,
            this.moduleName
        )
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                return {
                    name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Consumer),
                    type: 'form',
                    dataTypesToEdit: dataTypeInGroup,
                    dataTypesRequired: dataTypeInGroup
                }
            })

    }

    // #endregion
}